import {
  type SessionStorageKey,
  type SessionStorageTypeMap,
} from '@/shared/types/session-storage-types';
import { SessionSchemas } from '@/shared/types/session-storage-types';

export function setSessionStorage<K extends SessionStorageKey>(key: K, value: SessionStorageTypeMap[K]): void {
  if (globalThis.window === undefined) return;
  sessionStorage.setItem(key, JSON.stringify(value));
}

export function getSessionStorage<K extends SessionStorageKey>(key: K): SessionStorageTypeMap[K] | null {
  if (globalThis.window === undefined) return null;

  const raw = sessionStorage.getItem(key);

  if (!raw) return null;

  try {
    const schema = SessionSchemas[key];

    return schema.parse(JSON.parse(raw)) as SessionStorageTypeMap[K];
  } catch (error) {
    console.warn(`Invalid sessionStorage data for key "${key}":`, error);
    return null;
  }
}

export function removeSessionStorage<K extends SessionStorageKey>(key: K): void {
  if (globalThis.window === undefined) return;
  sessionStorage.removeItem(key);
}
